// eslint-disable-next-line import/no-cycle
import { fileThumbFormatter } from '../kdatatable/formatters';
import filePreviewModal from './modals/file-preview/file-preview-modal.component';
import filePreviewMultipleModal from './modals/file-preview-multiple/file-preview-multiple-modal.component';

/* globals Knitiv, Ktable */

/**
 * @param {import('@knitiv/api-client-javascript').KNode} kid
 * @param {import('angular').auto.IInjectorService} $injector
 * @returns {Promise<any>}
 */
export const viewFile = async (
	kid,
	$injector,
) => {
	/** @type {Knitiv.RootScope} */
	// @ts-ignore
	const $rootScope = $injector.get('$rootScope');
	const options = $rootScope.kds ? {
		...filePreviewMultipleModal({
			resolve: {
				kid: () => kid,
			},
		}),
	} : {
		...filePreviewModal({
			resolve: {
				kid: () => kid,
			},
		}),
	};

	const modalInstance = $injector.get('$uibModal').open(options);
	return modalInstance.result;
};

/**
 * Note: `options` is spread last, so an `options.contextMenu` takes precedence
 * over the `contextMenuHandler` argument. Callers that build their own column
 * definition should pass the handler through `options`, not through this argument.
 *
 * @param {*} contextMenuHandler Fallback context menu, used only when `options.contextMenu` is unset
 * @param {import('angular').auto.IInjectorService} $injector
 * @param {*} getData
 * @param {Partial<import('tabulator-tables').ColumnDefinition>} [options]
 * @returns {import('tabulator-tables').ColumnDefinition}
 */
export const createFileThumb = (
	contextMenuHandler,
	$injector,
	getData = (/** @type {import('tabulator-tables').CellComponent} */ cell) => cell.getData(),
	options = {},
) => ({
	headerSort:  false,
	title:       '',
	hozAlign:    'center',
	formatter:   cell => {
		/** @type {Ktable.RowData} */
		const { root } = getData(cell);
		// @ts-ignore
		return fileThumbFormatter(root, null, null, $injector);
	},
	contextMenu: contextMenuHandler,
	cellClick:   async (event, cell) => {
		const { root } = getData(cell);
		const {
			kid,
			file,
		} = root;

		if (file === 1) {
			await viewFile(kid, $injector);
		}
	},
	...options,
	tooltip: '',
});

/**
 * @param {Partial<import('tabulator-tables').ColumnDefinition>} [options]
 * @returns {import('tabulator-tables').ColumnDefinition}
 */
export const rowNumberColumnDefinition = (options = {}) => ({
	headerSort: false,
	title:      '',
	hozAlign:   'center',
	formatter:  'rownum',
	...options,
	tooltip: '',
});

/**
 *
 * @param {Partial<import('tabulator-tables').ColumnDefinition>} [options]
 * @param {?import('angular').auto.IInjectorService} [$injector]
 * @returns {import('tabulator-tables').ColumnDefinition}
 */
// export const rowSelectionColumnDefinition = (options = {}) => ({
// 	title: '',
// 	formatter:      'rowSelection',
// 	titleFormatter: 'rowSelection',
// 	hozAlign:       'center',
// 	headerSort:     false,
// 	...options,
// 	tooltip: null,
// });
export const rowSelectionColumnDefinition = (options = {}, $injector = null) => ({
	title:     '',
	formatter: 'rowSelection',
	// @ts-ignore
	titleFormatter: 'rowSelectionK',
	hozAlign:       'center',
	headerSort:     false,
	// @ts-ignore
	titleFormatterParams: {
		rowRange: 'active',
		$injector,
	},
	...options,
	tooltip: '',
});

/**
 *
 * @param {Partial<import('tabulator-tables').ColumnDefinition>} [options]
 * @param {import('angular').translate.ITranslateService} $translate
 * @param {import('angular').IScope} $scope
 * @param {import('angular').ICompileService} $compile
 * @param {*} getWorkflow
 * @returns {import('tabulator-tables').ColumnDefinition}
 */
export const createWorkflowCell = (
	options,
	$translate,
	$scope,
	$compile,
	getWorkflow = (/** @type {import('tabulator-tables').CellComponent} */ cell) => cell.getValue(),
) => ({
	formatter: cell => {
		/** @type {import('@knitiv/api-client-javascript').QueryCellContent['wf']} */
		const wf = getWorkflow(cell);

		let element = '';
		const noWorkflows = '<i title="Aucun workflow disponible"></i>';
		// const noWorkflows = '<i title="Aucun workflow disponible" class="fa fa-exclamation-circle"></i>';

		if (wf && wf.length > 0 && wf[0] !== undefined) {
			/** @type {import('angular').IScope & {wf?: import('@knitiv/api-client-javascript').QueryCellContent['wf']}} */
			const scope = $scope.$new(true);
			scope.wf = wf;
			element = '<wf-icon wf="wf" />';
			return $compile(element)(scope)[0];
		}

		return noWorkflows;
	},
	hozAlign:  'center',
	sorter:    'exists',
	title:     '',
	...options,
	tooltip: '',
});
